/**
 * #2052 — reset the window's scroll when the PAGE changes.
 *
 * React Router keeps `window.scrollY` across client-side navigations, so a
 * link low on Home (the *Needs you* card) opened `/roster?from=…` already
 * scrolled down. The app shell scrolls on `window` (`<AppShell/>` is
 * `min-h-screen` with a sticky header, no inner `overflow-auto` element),
 * so `window.scrollTo(0, 0)` is the right target. The member app keeps its
 * own per-tab inner scroll (`MemberAppLayout`), which this leaves alone.
 *
 * Only a PATHNAME change scrolls: the roster page rewrites
 * `?from/to/preset/show` constantly and must not jump. Skipped:
 *   - back/forward (navigation type POP) — keep the browser's position;
 *   - a location with a `#hash` — the hash target decides the position;
 *   - the first render — nothing has navigated yet.
 */
import { useEffect, useRef } from "react";
import { useLocation, useNavigationType } from "react-router-dom";

export function ScrollToTopOnRouteChange() {
  const { pathname, hash } = useLocation();
  const navigationType = useNavigationType();
  const previousPathname = useRef(pathname);

  useEffect(() => {
    if (previousPathname.current === pathname) return;
    previousPathname.current = pathname;
    if (navigationType === "POP" || hash) return;
    window.scrollTo(0, 0);
  }, [pathname, hash, navigationType]);

  return null;
}
